<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap align-center>
        <v-flex 
          v-for="img in cardImgs" 
          :key="img" 
          xs12 sm4 md2
        >
          <v-card 
            dark
            :img="img"
            height="200"
          >
          </v-card>
        </v-flex>
      
    </v-layout>
  </v-container>
  
</template>

<script>
export default {
  data () {
    return {
      cardImgs: [
        'https://images.unsplash.com/photo-1514855044665-e7e540b3edc8?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=5fa3d307c2c2cf212b6dfe501b37e907&auto=format&fit=crop&w=1315&q=80',
        'https://images.unsplash.com/photo-1536168032936-9ce3b4b3165c?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f4ae154404e5ae607280b942357aa345&auto=format&fit=crop&w=1348&q=80',
        'https://images.unsplash.com/photo-1473091734859-44ec098bdd22?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c7d97be9ee5d99d9ef36310bc04bab83&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1515735543535-12664d2453f8?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=18b4fab0372d3285ef16bf0a669fe08f&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1437622368342-7a3d73a34c8f?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=a6c7403def67925a904f16b7ee87695b&auto=format&fit=crop&w=1400&q=80',
        'https://images.unsplash.com/photo-1538913296881-2cc7efee3b6a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=a10a4a3b76ebd33404d9201857ebd94a&auto=format&fit=crop&w=1349&q=80',
        'https://images.unsplash.com/photo-1516683169270-7514e272a5fc?ixlib=rb-0.3.5&s=6afae34533db41f1680242897a5af636&auto=format&fit=crop&w=1352&q=80',
        'https://images.unsplash.com/photo-1498574932731-e711f7092d07?ixlib=rb-0.3.5&s=297684f3d9952c4cee35df3f25bd8486&auto=format&fit=crop&w=1373&q=80',
        'https://images.unsplash.com/photo-1513040046889-d892d595512d?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=fdfe473b8eeb192a86cc8d9aeb2a87fa&auto=format&fit=crop&w=1330&q=80',
        'https://images.unsplash.com/photo-1517009988936-bfaf7497092e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=faa8e94fcd494b416d9362664454cb34&auto=format&fit=crop&w=1371&q=80',
        'https://images.unsplash.com/photo-1517880014665-8b84b2e26002?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f68dce4bbc5a44c6e499aec220423bd2&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1516970739312-08b075784b71?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=aa9cbab3688a65554b73df1e18a315ef&auto=format&fit=crop&w=1355&q=80'
      ]
    }
  },
  props: ['loops']
}
</script>



// WEBPACK FOOTER //
// src/components/content_fill/FishCardFill.vue